import { useEffect, useState } from 'react';
export const useCurrentUrl = () => {
    const [url, setUrl] = useState(null);
    useEffect(() => {
        setUrl(window.location.pathname + window.location.search || null);
    }, []);
    return url;
};
//# sourceMappingURL=useCurrentUrl.js.map